import React, { useEffect, useReducer, useCallback } from 'react';

// CSS
import styles from './LoggerStatus.scss';

// MANAGERS
import { Logger, LoggerLevel, LoggerSource } from '@Managers/Logger';

function LoggerFilter() {
    const [state, setState] = useReducer(
        (
            state: {
                filterName: string;
                filterOptions: Array<string>;
            },
            newState: any
        ) => ({ ...state, ...newState }),
        {
            filterName: '',
            filterOptions: []
        }
    );

    useEffect(() => {
        updateData(Logger.getFilters());
    }, []);

    function updateData(filters?: Array<string>) {
        setState({
            filterOptions: filters ? filters : state.filterOptions
        });
    }

    function filterName(evt: React.FormEvent<HTMLInputElement>) {
        setState({ filterName: evt.currentTarget.value });
    }

    function submitFilter(evt: React.KeyboardEvent<HTMLInputElement> | any) {
        const _name = new String(state.filterName);
        if ((evt.code === 'Enter' || evt.type === 'click') && _name.length > 0) {
            setState({ filterName: '', filterOptions: Logger.setFilterName(state.filterName) });
        }
    }

    function deleteFilter(name: string) {
        setState({ filterName: '', filterOptions: Logger.deleteFilterName(name) });
    }

    return (
        <div>
            <div>Filter by LOG Label:</div>
            <div>
                <div>
                    <input type="text" id="" name="" onInput={(evt) => filterName(evt)} value={state.filterName} onKeyPress={(evt) => submitFilter(evt)} />
                    <button onPointerDown={(evt) => submitFilter(evt)}>Add</button>
                </div>
                <div>
                    <div>
                        {state.filterOptions.map((value: string, key: any) => (
                            <div key={key}>
                                {value} <button onPointerDown={() => deleteFilter(value)}>X</button>{' '}
                            </div>
                        ))}
                    </div>
                </div>
            </div>
        </div>
    );
}

export default LoggerFilter;
